import { Injectable, Component } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmPopupComponent } from './confirm-popup.component';

@Injectable()
export class ConfirmPopupService {
    private ngbModalRef: NgbModalRef;
    private data: any;
    private confirmData: any;

    constructor(
        private modalService: NgbModal,
    ) {}

    getConfirmData() {
        return this.confirmData;
    }

    confirmPopupModalRef(component: Component, confirmData) {
        const modalRef = this.modalService.open(component, { size: 'lg', backdrop: true});

        modalRef.componentInstance.confirmData = confirmData;

        return modalRef;
    }

    open(confirmData) {
        this.ngbModalRef = this.confirmPopupModalRef(ConfirmPopupComponent as Component, confirmData);

        return this.ngbModalRef.result.then((confirm) => {
            return !!confirm;
        }).catch(() => {
            return false;
        });
    }
}
